import { Component, OnInit } from '@angular/core';
import { IReservation } from '../../../../models/reservation.model';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ReservationService } from '../../../../services/reservation.service';
import { StatusService } from '../../../../services/status.service';
import { IStatus } from '../../../../models/status.model';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.scss']
})
export class ReservationComponent implements OnInit {
  home = 'HOME';
  desktop = 'DESKTOP';
  others = 'OTHERS';
  seller = 'SELLER';
  constructor(private fb: FormBuilder,
              private reservationService: ReservationService,
              private statusService: StatusService) { }

  get f1() { return this.editReservationForm.controls; }

  // @ts-ignore
  reservation: IReservation[] = [];
  all: IReservation[] = [];
  // @ts-ignore
  currentReservation: IReservation = [];
  url_photo: String;
  statusResa: IStatus[] = [];

  /*
   -----------------------------         for all page attribute    --------------------------------
   */
   search: any;
   pageNumber: number = 1;
   pageSize: number = 10;
   totalItems :any;
   /*
   end for all page
    */
  sorted = false;
  sorted1 = false;
  sorted2 = false;
  sorted3 = false;
  sorted4 = false;
  sorted5 = false;
  sorted6 = false;
  sorted7 = false;
  sorted8 = false;
  sorted9 = false;
  sorted10 = false;
  sorted11 = false;
  sorted12 = false;
  sorted13 = false;

  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  endDateVal: any = null;
  disableEndDate: boolean = true;
  selectedStatus = "";
  editReservationForm = this.fb.group({
    id: new FormControl(this.currentReservation.id, [ ])
  });

  ngOnInit(): void {
    this.loadReservation();
    this.loadStatusReservation();
    this.url_photo = environment.url_photo;
  }

  loadReservation = () => {

    this.reservationService.getAllReservation_v1(this.pageNumber-1, this.pageSize).subscribe(data => {
        this.reservation = data.content;
        this.totalItems = data.totalElements;
       // console.log('From réservation component');
        //console.log(this.reservation);
         this.reservation.forEach(element => {
            element.total = 0;

            element.total += Number(element.post.postServiceModels[0]?.price) + Number(element?.selectedZone?.default_price);
         });
         this.all = this.reservation;
        // console.log(this.all)
      }, (err) => {
        //console.log('-----> err', err);
      });
  }

  dateForm = this.fb.group({
    beginDate: ['', Validators.required],
    endDate: ['', Validators.required]
  })

  filterByDate() {
    const beginDate = this.dateForm.get('beginDate').value;
    const endDate = this.dateForm.get('endDate').value;

    // Vérifier si les deux champs de date sont vides
    if (!beginDate || !endDate) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    } else {
      // const beginDateISO = new Date(beginDate).toISOString();
      // const endDateISO = new Date(endDate).toISOString();
      this.reservationService.getAllReservation_v1(this.pageNumber-1, this.pageSize,this.beginDateVal, this.endDateVal, this.search, this.selectedStatus).subscribe(data => {
        this.reservation = data.content;
        this.totalItems = data.totalElements;
         this.reservation.forEach(element => {
            element.total = 0;
  
            element.total += Number(element.post.postServiceModels[0]?.price) + Number(element?.selectedZone?.default_price);
         });
         this.all = this.reservation;
      }, (err) => {
      });
      
    }
  }

  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-post');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

  // Fonction pour formater la date au format "YYYY-MM-DD"
  formatDate(date: string): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }

  getEndDate(event: any) {
    this.endDateVal = event.target.value;
    //console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  refresh() {
    this.loadReservation();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }

  deleteReservation(id: any) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez-vous vraiment supprimer cette réservation ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.reservationService.deleteReservation(id).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'La réservation supprimée avec succès"',
            showConfirmButton: false,
            timer: 1500
          });
          this.loadReservation();
        },error => {
          // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 5500
          })
        });
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',

        });
      }
    });
  }

  onViewOrder(id: any) {
    this.reservationService.getIdReservation(id).subscribe(rs => {
      this.currentReservation = rs;
      // console.log('Testtt' + id);
      // console.log(this.currentReservation);
    });
  }

  /*
  -----------------------------          for all page methodes      -----------------------------
   */

  displayPerPage(event: any) {
    this.pageSize = event.target.value;
    this.loadReservation();
  }

  searchFilter($event: KeyboardEvent) {
    this.search = this.search !== undefined ? this.search : '';
    this.reservationService.getAllReservation_v1(this.pageNumber-1, this.pageSize, this.beginDateVal, this.endDateVal, this.search).subscribe(data => {
      this.reservation = data.content;
      this.totalItems = data.totalElements;
      this.reservation.forEach(element => {
          element.total = 0;

          element.total += Number(element.post.postServiceModels[0]?.price) + Number(element?.selectedZone?.default_price);
       });
       this.all = this.reservation;
      // console.log(this.all)
    }, (err) => {
      //console.log('-----> err', err);
    });
  }

  filterByShopChannelNumber(reservation: any): string{
   // console.log("Test affichage");
    if(reservation?.postServiceModels != undefined && reservation?.post?.postServiceModels[0]?.serviceModel?.shop?.channelNumber != undefined){
      return reservation?.post?.postServiceModels[0]?.serviceModel?.shop?.channelNumber;
    }
    return ""
  }

  filterByShopChannelName(reservation: any): string{
    if(reservation?.post?.postServiceModels != undefined && reservation?.post?.postServiceModels[0]?.serviceModel?.shop?.channelName != undefined){
      return reservation?.post?.postServiceModels[0]?.serviceModel?.shop?.channelName;
    }
    return ""
  }

  filterByShopChannelAdress(reservation: any): string{
    if(reservation?.post?.postServiceModels != undefined && reservation?.post?.postServiceModels[0]?.serviceModel?.shop?.address != undefined && reservation?.post){
      return reservation?.post?.postServiceModels[0]?.serviceModel?.shop?.address;
    }
    return ""
  }

  loadStatusReservation = () => {
    this.statusService.getStatusReservation()
      .subscribe(data => {
        this.statusResa = data;
        // console.log("Statut des réservations");
        // console.log(data);
      }, (err) => {
        //console.log('-----> err', err);
      });
  }

  /*
  end for all page
   */


  sort1() {
    if (this.sorted1 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a.id > b.id ? 1 : a.id < b.id ? -1 : 0);
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a.id < b.id ? 1 : a.id > b.id ? -1 : 0);
      this.sorted1 = false;
    }
  }

  sort2() {
    if (this.sorted2 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a.motif > b.motif ? 1 : a.motif < b.motif ? -1 : 0);
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a.motif < b.motif ? 1 : a.motif > b.motif ? -1 : 0);
      this.sorted2 = false;
    }
  }

  sort3() {
    if (this.sorted3 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a.firstName > b.firstName ? 1 : a.firstName < b.firstName ? -1 : 0);
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a.firstName < b.firstName ? 1 : a.firstName > b.firstName ? -1 : 0);
      this.sorted3 = false;
    }
  }

  sort4() {
    if (this.sorted4 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a.user.lastname > b.user.lastname ? 1 : a.user.lastname < b.user.lastname ? -1 : 0);
      this.sorted4 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a.user.lastname < b.user.lastname ? 1 : a.user.lastname > b.user.lastname ? -1 : 0);
      this.sorted4 = false;
    }
  }
  sort4_0() {
    if (this.sorted4 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a.user.firstname > b.user.firstname ? 1 : a.user.firstname < b.user.firstname ? -1 : 0);
      this.sorted4 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a.user.firstname < b.user.firstname ? 1 : a.user.firstname > b.user.firstname ? -1 : 0);
      this.sorted4 = false;
    }
  }

  sort5() {
    if (this.sorted5 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a.user?.phoneNumber > b.user?.phoneNumber ? 1 : a.user?.phoneNumber < b.user?.phoneNumber ? -1 : 0);
      this.sorted5 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a.user?.phoneNumber < b.user?.phoneNumber ? 1 : a.user?.phoneNumber > b.user?.phoneNumber ? -1 : 0);
      this.sorted5 = false;
    }
  }

  sort6() {
    if (this.sorted6 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a.user?.address > b.user?.address ? 1 : a.user?.address < b.user?.address ? -1 : 0);
      this.sorted6 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a.user?.address < b.user?.address ? 1 : a.user?.address > b.user?.address ? -1 : 0);
      this.sorted6 = false;
    }
  }
  sort7() {
    if (this.sorted7 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a.reservationDate > b.reservationDate ? 1 : a.reservationDate < b.reservationDate ? -1 : 0);
      this.sorted7 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a.reservationDate < b.reservationDate ? 1 : a.reservationDate > b.reservationDate ? -1 : 0);
      this.sorted7 = false;
    }
  }

  sort8() {
    if (this.sorted8 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a.reservationDate > b.reservationDate ? 1 : a.reservationDate < b.reservationDate ? -1 : 0);
      this.sorted8 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a.reservationDate < b.reservationDate ? 1 : a.reservationDate > b.reservationDate ? -1 : 0);
      this.sorted8 = false;
    }
  }
  sort9() {
    if (this.sorted9 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a.reservationPlace > b.reservationPlace ? 1 : a.reservationPlace < b.reservationPlace ? -1 : 0);
      this.sorted9 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a.reservationPlace < b.reservationPlace ? 1 : a.reservationPlace > b.reservationPlace ? -1 : 0);
      this.sorted9 = false;
    }
  }
  sort10() {
    if (this.sorted10 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a.status?.name > b.status?.name ? 1 : a.status?.name < b.status?.name ? -1 : 0);
      this.sorted10 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a.status?.name < b.status?.name ? 1 : a.status?.name > b.status?.name ? -1 : 0);
      this.sorted10 = false;
    }
  }
  sort11() {
    if (this.sorted11 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a?.selectedZone?.default_price > b?.selectedZone?.default_price ? 1 : a?.selectedZone?.default_price < b?.selectedZone?.default_price ? -1 : 0);
      this.sorted11 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a?.selectedZone?.default_price < b?.selectedZone?.default_price ? 1 : a?.selectedZone?.default_price > b?.selectedZone?.default_price ? -1 : 0);
      this.sorted11 = false;
    }
  }
  sort12() {
    if (this.sorted12 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a?.post?.postServiceModels[0]?.price > b?.post?.postServiceModels[0]?.price ? 1 : a?.post?.postServiceModels[0]?.price < b?.post?.postServiceModels[0]?.price ? -1 : 0);
      this.sorted12 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a?.post?.postServiceModels[0]?.price < b?.post?.postServiceModels[0]?.price ? 1 : a?.post?.postServiceModels[0]?.price > b?.post?.postServiceModels[0]?.price ? -1 : 0);
      this.sorted12 = false;
    }
  }
  sort13() {
    if (this.sorted13 == false) {
      // @ts-ignore
      this.reservation.sort((a, b) => a.total > b.total ? 1 : a.total < b.total ? -1 : 0);
      this.sorted13 = true;
    } else {
      // @ts-ignore
      this.reservation.sort((a, b) => a.total < b.total ? 1 : a.total > b.total ? -1 : 0);
      this.sorted13 = false;
    }
  }

  selectReservationStatus(value: any) {
    this.selectedStatus = value;
    if (value !== 'all') {
      this.reservationService.getAllReservation_v1(this.pageNumber-1, this.pageSize,this.beginDateVal, this.endDateVal, this.search, this.selectedStatus).subscribe(data => {
        this.reservation = data.content;
        this.totalItems = data.totalElements;
       // console.log('From réservation component');
        //console.log(this.reservation);
         this.reservation.forEach(element => {
            element.total = 0;
  
            element.total += Number(element.post.postServiceModels[0]?.price) + Number(element?.selectedZone?.default_price);
         });
         this.all = this.reservation;
      }, (err) => {
      });
    }else{
      this.loadReservation();
    }
  }
}

